import * as React from 'react'
import { FC, useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { ExpectedClosingDateDue } from './Sections/ExpectedClosingDateDue'
import { getData } from '@user/store/dashboard/widgets/upcomingFollowUps/api'
import { NextActionDateDue } from './Sections/NextActionDateDue'
import { selectUpcomingFollowUps } from '@user/store/dashboard/widgets/upcomingFollowUps/slice'
import { mapDashboardDataToFilters } from '@user/store/dashboard/mapper'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { useCheckPermissions } from '@user/store/authorization/permissions'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'

export const ContentFront: FC = () => {
  const dispatch = useAppDispatch()
  const { assigneeId, data, salesTeamId, numberOfDays } = useSelector(
    selectUpcomingFollowUps,
  )

  const [_, assignees, __, salesTeams] = useMemo(
    () => mapDashboardDataToFilters(data),
    [data],
  )

  const [canViewLeads, canViewOpps] = useCheckPermissions(
    'leads_view',
    'opportunities_view',
  )

  useEffect(() => {
    dispatch(getData())
  }, [assigneeId, dispatch, numberOfDays, salesTeamId])

  return (
    <>
      <NextActionDateDue
        days={numberOfDays || 7}
        leadCount={data.leadsNextActionDateDue}
        oppCount={data.opportunitiesNextActionDateDue}
        assignees={assignees}
        salesTeams={salesTeams}
        canViewLeads={canViewLeads}
        canViewOpps={canViewOpps}
      />

      <Box my={1}>
        <Divider />
      </Box>

      <ExpectedClosingDateDue
        count={data.opportunitiesClosingDateDue}
        days={numberOfDays}
        salesTeams={salesTeams}
        assignees={assignees}
        canViewOpps={canViewOpps}
      />
    </>
  )
}

ContentFront.displayName = 'UpcomingFollowUpsContentFront'
